import { createReducer } from "@reduxjs/toolkit";
import { AgentViewTypes } from "constants/ChatViewConstants";
import { CHANGE_AGENT_VIEW } from "actions/types";

const initialState = AgentViewTypes.DEFAULT;
const agentViewReducer = createReducer(initialState, {
  [CHANGE_AGENT_VIEW]: (state, action) => {
    state = action.payload;
    return state;
  },
});

export default agentViewReducer;
